import axios from "axios";
import env from "../environments/env";
import "./interceptor";

export const Get = async (url, params, config) => {
  try {
    const res = await axios.get(`${env.API_URL}/${url}`, {
      params,
      ...config,
    });
    return res.data;
  } catch (err) {
    throw handleErrorResponse(err);
  }
};

export const Post = async (url, body, config) => {
  try {
    const res = await axios.post(`${env.API_URL}/${url}`, body, config);
    return res.data;
  } catch (err) {
    throw handleErrorResponse(err);
  }
};

export const Put = async (url, body, config) => {
  try {
    const res = await axios.put(`${env.API_URL}/${url}`, body, config);
    return res.data;
  } catch (err) {
    throw handleErrorResponse(err);
  }
};

export const Delete = async (url, body, config) => {
  try {
    const res = await axios.delete(`${env.API_URL}/${url}`, body, config);
    return res.data;
  } catch (err) {
    throw handleErrorResponse(err);
  }
};

export const handleErrorResponse = (err) => {
  const { response = {}, message } = err;
  const { status = null, statusText = null, data = {} } = response;
  let error = {
    status,
    statusText,
    data,
  };

  if (message === "Network Error") {
    error = {
      ...error,
      error: "network",
    };
    return error;
  }

  if (status === 401) {
    error = {
      ...error,
      error: "unauthorized",
    };
    return error;
  }

  if (status === 400) {
    error = {
      ...error,
      error: "badrequest",
    };
    return error;
  }

  error = {
    ...error,
    error: "server",
  };

  return error;
};
